
export default class AvailabilityPeriodModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.start = data.start ? new Date(data.start) : null;
    this.end = data.end ? new Date(data.end) : null;
  }
}
